import { useState } from "react"

import { KeuzeWijzerState } from "../../logic/keuzewijzer/keuzewijzerstate"
import { masterData } from "../../logic/keuzewijzer/keuzewijzermasterdata"
import { StateMachine } from "../../logic/statemachine/statemachine"
import { IntroPage } from "./IntroPage"

export default function KeuzeWijzerPage() {
  let [introVisible, setIntroVisible] = useState(true)
  let [state, setState] = useState(new KeuzeWijzerState())

  function goToIntroPage() {
    setIntroVisible(true)
    setState(new KeuzeWijzerState())
  }

  if (introVisible) {
    return (< IntroPage goToNextPage={() => setIntroVisible(false)} />)
  }

  const stateMachine = new StateMachine(masterData)

  const result = stateMachine.getResult(state)
  if (result === undefined) {
    return stateMachine.renderNextStep(state, setState)
  }
  return stateMachine.renderResult(state, goToIntroPage)
}
